export interface Settings {
    baseURL: string | undefined;
    appName: string | undefined;
    version?: string;
}

const settings: Settings = {
    baseURL: process.env.VUE_APP_BASE_API,
    appName: process.env.VUE_APP_APPNAME
}

export default settings;
